(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-features-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal(root) {
      var targets = root.querySelectorAll('[data-afh-card], [data-afh-panel]');
      if (!targets.length) return;
      if (!('IntersectionObserver' in window)) {
        targets.forEach(function (el) {
          var suffixClass = Array.prototype.filter.call(el.classList, function (c) { return c.indexOf('afh-card-') === 0 || c.indexOf('afh-panel-') === 0; })[0];
          if (suffixClass) el.classList.add(suffixClass.replace('afh-card-', 'afh-in-view-').replace('afh-panel-', 'afh-in-view-'));
        });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var baseClass = Array.prototype.filter.call(el.classList, function (c) {
            return (c.indexOf('afh-card-') === 0 || c.indexOf('afh-panel-') === 0) && c.indexOf('afh-in-view-') !== 0;
          })[0];
          if (baseClass) {
            var suffix = baseClass.replace('afh-card-', '').replace('afh-panel-', '');
            el.classList.add('afh-in-view-' + suffix);
          }
          observer.unobserve(el);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    }

    function initSmoothAnchors(root) {
      var links = root.querySelectorAll('a[href^="#feature-"]');
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var id = link.getAttribute('href').slice(1);
          var target = document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function init() {
      document.querySelectorAll('[id^="shopify-section"]').forEach(function (section) {
        var root = section.querySelector('[class*="afh-"]');
        if (!root) return;
        initReveal(section);
        initSmoothAnchors(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-tryon-banner"] && !Shopify.designMode) return;
  try {
    
  // Several sections on this theme (hero banners, this AI Tryon Banner's
  // neighbors, etc.) render a background image with object-fit: contain.
  // Whenever that image's aspect ratio doesn't match its container, the
  // browser letterboxes blank space above and below the actual photo,
  // which shows up as an unwanted "gap" against whatever section sits
  // next to it. The exact size of that blank strip depends on the visible
  // width and the section's own height setting, so it's different on
  // every screen size/orientation and can't be hardcoded as a fixed pixel
  // offset (that was tried before and broke on other viewport widths).
  //
  // A first version of this fix pulled the letterboxed section's own
  // margins inward (negative margin-top/bottom) to visually close the
  // gap. That closed the visible gap but made the section's box
  // physically overlap its neighbor - and since hero sections render a
  // full-bleed invisible link (.hero__link, used for "tap anywhere to
  // shop") across their whole box, that overlap let one section's click
  // target bleed on top of the next section's content, breaking clicks
  // (e.g. this banner's product card links). Overlap is never safe here.
  //
  // Fix instead: shrink the letterboxed section's own height down to
  // exactly match its photo's real rendered height, so the blank strip
  // is eliminated at the source and neighboring sections simply sit
  // flush against each other in normal document flow - zero gap, zero
  // overlap, on any device.
  //
  // Note: inline <script> tags inside section markup do not reliably
  // execute on this theme, so this uses the {% javascript %} tag, which
  // Shopify compiles into a real external asset that always runs.
  (function () {
    function measureNeededHeight(img) {
      // Returns null when we can't get a confident reading yet (image not
      // loaded/laid out), or when there's no letterbox to fix, so callers
      // leave any existing state alone instead of wiping it out on an
      // inconclusive check.
      if (!img || !img.complete || !img.naturalWidth || !img.naturalHeight) return null;
      var box = img.getBoundingClientRect();
      if (box.width <= 0 || box.height <= 0) return null;
      if (getComputedStyle(img).objectFit !== 'contain') return null;
      var imgAspect = img.naturalWidth / img.naturalHeight;
      var boxAspect = box.width / box.height;
      if (imgAspect <= boxAspect) return null; // no vertical letterbox here
      return box.width / imgAspect; // exact height with zero letterbox
    }

    function heroImage(section) {
      var grid = section.querySelector('.hero__media-grid');
      return grid ? grid.querySelector('img') : null;
    }

    function adjustSection(section) {
      var heroEl = section.querySelector('.hero');
      if (!heroEl) return;
      var neededHeight = measureNeededHeight(heroImage(section));
      if (neededHeight === null) return;
      heroEl.style.setProperty('--hero-min-height', neededHeight.toFixed(1) + 'px');
    }

    function initSection(section) {
      if (section.dataset.gapInit) return;
      section.dataset.gapInit = '1';
      var pending = null;
      // Uses setTimeout rather than requestAnimationFrame - rAF only
      // fires on an actual paint, which can be suppressed or delayed for
      // tabs that aren't visually active/foregrounded, silently stalling
      // the whole fix in that case. setTimeout always runs.
      function schedule() {
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () {
          adjustSection(section);
        }, 16);
      }

      schedule();
      window.addEventListener('resize', schedule);

      var img = heroImage(section);
      if (img) {
        if (img.complete) schedule();
        else img.addEventListener('load', schedule);
        // Fires whenever the image's actual rendered box size changes -
        // window resize, orientation change, zoom, responsive breakpoints.
        if (window.ResizeObserver) {
          new ResizeObserver(schedule).observe(img);
        }
      }
      // Fallback checks for late layout shifts (webfonts, async content).
      setTimeout(schedule, 300);
      setTimeout(schedule, 1000);
      setTimeout(schedule, 2500);
    }

    function init() {
      Array.prototype.forEach.call(
        document.querySelectorAll('[id^="shopify-section"]'),
        function (section) {
          if (heroImage(section)) initSection(section);
        }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
